// extracted by css-extract-rspack-plugin
export default {"container":"P4fBHPn6lzosPANU","snippetSection":"FK1wXb1PE6oh7Rva","labeledSection":"YdQuW0MVOkpyNkwA","initializeBody":"b2qlcoYv2EiO32Es","sdkKeysInstructions":"S5RmzAp2tigRpTYl"};